import { Box, Theme, Typography } from "@mui/material";
import { SystemCssProperties } from "@mui/system";
import { ComponentProps } from "react";

export const TwoLiner = ({
  primary,
  primaryColor,
  secondary,
  secondaryColor = "text.secondary",
  onClick,
  disabled,
  sx,
}: {
  primary: string | number | null;
  primaryColor?: SystemCssProperties<Theme>["color"];
  secondary: string | number | null;
  secondaryColor?: SystemCssProperties<Theme>["color"];
  onClick?: () => void;
  disabled?: boolean;
  sx?: ComponentProps<typeof Box>["sx"];
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{ ...sx, cursor: onClick ? "pointer" : undefined }}
    >
      <Typography sx={{ color: disabled ? "text.disabled" : primaryColor }}>
        {primary}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: disabled ? "text.disabled" : secondaryColor }}
      >
        {secondary}
      </Typography>
    </Box>
  );
};
